import React from 'react';
import cx from 'classnames';
import styles from '../FieldsTab.module.scss';

interface InfoBoxProps {
    isSingleStep: boolean;
    showMultistepUI: boolean;
    shouldShowMultistepUI: boolean;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ isSingleStep, showMultistepUI, shouldShowMultistepUI }) => {
    const getMessage = (): string => {
        if (isSingleStep && !showMultistepUI) {
            return 'Fügen Sie Felder zu Ihrem Formular hinzu. Sie können später Multi-Step-Modus aktivieren, um Ihre Felder in mehrere Schritte zu organisieren.';
        }
        if (shouldShowMultistepUI) {
            return 'Organisieren Sie Ihre Felder in Schritten. Multi-Step-Modus ist aktiviert.';
        }
        return 'Organisieren Sie Ihre Felder in Schritten.';
    };

    return (
        <div className={cx(styles['info-box'], 'zr-mb-3')}>
            <p>{getMessage()}</p>
        </div>
    );
};

